// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CameraTwoToneSvg from "@fishx/icons-svg/es/asn/CameraTwoTone";
import FishxIcon from '../components/FishxIcon';

var CameraTwoTone = function CameraTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CameraTwoToneSvg
  }));
};

CameraTwoTone.displayName = 'CameraTwoTone';
export default React.forwardRef(CameraTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CameraTwoTone.js
// module id = 2160
// module chunks = 0